import type { SportsFilter } from "@/types/filters.types";
import { atom } from "jotai";
import type { DateRange } from "react-day-picker";

/**
 * Free-text search
 */
export const queryAtom = atom<string>("");

/**
 * Multi-sport filter
 * undefined === All sports
 */
export const sportsAtom = atom<SportsFilter>({ mode: "all" });

/**
 * Date range filter
 * undefined.from === not selected yet
 */
export const dateRangeAtom = atom<DateRange>({
  from: undefined,
  to: undefined,
});

/**
 * Results limit
 */
export const limitAtom = atom<number | undefined>(1000);

export const resetFiltersAtom = atom(null, (_get, set) => {
  set(queryAtom, "");
  set(sportsAtom, { mode: "all" });
  set(dateRangeAtom, { from: undefined });
  set(limitAtom, undefined);
});

/**
 * Private vs public activities
 */
export const showPublicActivitiesAtom = atom<boolean | undefined>(undefined);
